module.exports = __webpack_public_path__ + "static/media/swingintime2.fb0374ef.jpg";